<template>
    <layout>
        <v-row 
            align="center"
            justify="center"
        >
        <v-card
            class="mt-7"
            width="500"
        >  
           
            <v-toolbar 
                color="primary"
                dark
            >
                <v-toolbar-title>Term Reports</v-toolbar-title>  
            </v-toolbar>
            <v-list two-line>
                <v-list-item-group
                    v-model="selected"
                    active-class="primary--text"
                    multiple
                >
                    <template v-for="(item, index) in items">
                        <v-list-item :key="item.term" @click="reportCard=true">
                            <template v-slot:default="{ active }">
                                <v-list-item-content>
                                    <v-list-item-title v-text="item.title"></v-list-item-title>

                                    <v-list-item-subtitle
                                        class="text--primary"
                                        v-text="item.headline"
                                    ></v-list-item-subtitle>                                  

                                   
                                    <v-list-item-subtitle
                                        v-text="item.subtitle"
                                    ></v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-list-item-action-text v-text="item.action"></v-list-item-action-text>
                                    <v-icon
                                        v-if="!active"
                                        color="grey lighten-1"
                                    >
                                        mdi-star-outline
                                    </v-icon>

                                    <v-icon
                                        v-else
                                        color="yellow darken-3"
                                    >
                                        mdi-star
                                    </v-icon>

                                </v-list-item-action>

                                

                            </template>
                        </v-list-item>

                        <v-divider
                            v-if="index < items.length - 1"
                            :key="index"
                        ></v-divider>

                    </template>
                </v-list-item-group>
            </v-list>
            
        </v-card>
        </v-row>
        
        
        <v-dialog
            v-model="reportCard"
            max-width="700px"

        >
            <v-card
               height="90vh" 
            >                
                <iframe ref="pdf" style="width:100%; height:100%" class="registration-form" :src="src"></iframe>              
                    
            </v-card>
        </v-dialog>        
    </layout>    
</template>

<script>
import Layout from './layouts/App';

export default {
    name: 'TermReport',
    components: {
        Layout,
    },
    
    data: () => ({
        reportCard: false,
        selected: [2],
        items: [
            {
                action: 'Dec 12 2020',
                headline: 'End of Term Report',
                subtitle: 'Term 1 2020-2021',
                title: 'Form 1',
                term: 'T120202021'
            },
            {
                action: 'Sept 12 2021',
                headline: 'End of Term Report',
                subtitle: 'Term 2 2020-2021',
                title: 'Form 1',
                term: 'T220202021'
            }
        ],
        src: "http://localhost:8000/api/report-card"
        //src: "",       
        

    }),

   
    
}
</script>